import { FC } from 'react';

import { BonusVia } from '../../events';
import { useEventListeners } from '../../hooks/use-event-listeners';
import { useGiveModal } from '../../hooks/use-give-modal';
import { useInitGiveRecognitionModal } from '../../hooks/use-init-give-recognition-modal';
import { GiveModal } from './give-modal';

type GlobalGiveBoxProps = {
	onSuccess?: () => void;
	via?: BonusVia;
};

export const GlobalGiveBox: FC<GlobalGiveBoxProps> = ({ onSuccess, via: propVia, ...props }) => {
	useEventListeners();
	useInitGiveRecognitionModal();
	const giveModal = useGiveModal({ onSuccess });

	// Keep the Bizy hand-off channel (`giveModal.via`) and the static per-app
	// channel (`propVia`, e.g. "ms_teams") distinct. Attribution credits Bizy
	// only when it drafted the body; otherwise it records `baseVia`, so a
	// from-scratch rewrite in MS Teams stays "ms_teams" rather than web.
	return <GiveModal {...giveModal} {...props} via={giveModal.via} baseVia={propVia} />;
};
